<template>
  <div class="spinnerloading-box">
    <div class="spinner"></div>
    <p class="loading-text">
      <slot name="loadingtext"></slot>
    </p>
  </div>
</template>
<script>
export default {};
</script>
<style scoped src="@/assets/css/commonspinnerloading/commonspinnerloading.css"></style>
